import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DropdownItem from '../../common/components/_DropdownItem';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';


function CareersSidebarFilter({ filters, search }) {
	return (
            <div className="large-3 column">
                <span className="filter-results large-push-6">
                     Filter results
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon"><use xlinkHref="#icon-filter"></use></svg>
                </span>
                <p></p>
                {filters && filters.taxonomyFilters && <DropdownItem search={search} title='Contract' options={filters.taxonomyFilters.contractType} name='contractType' istaxonomy={true} />}
            </div>		
	);
}

CareersSidebarFilter.propTypes = {
    entries: PropTypes.object,
    filters: PropTypes.object,
    search: PropTypes.object,
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(CareersSidebarFilter);
